import React, { useState, useEffect } from 'react';

const OperatingHoursInput = ({ formData, setFormData }) => {
  const defaultHours = {
    Monday: { open: false, start: "9:00 AM", end: "5:00 PM" },
    Tuesday: { open: false, start: "9:00 AM", end: "5:00 PM" },
    Wednesday: { open: false, start: "9:00 AM", end: "5:00 PM" },
    Thursday: { open: false, start: "9:00 AM", end: "5:00 PM" },
    Friday: { open: false, start: "9:00 AM", end: "5:00 PM" },
    Saturday: { open: false, start: "10:00 AM", end: "4:00 PM" },
    Sunday: { open: false, start: "Closed", end: "Closed" },
  };

  // Initialize operatingHours from formData if available, otherwise use defaultHours
  const [operatingHours, setOperatingHours] = useState(formData.hours || defaultHours);

  const timeSlots = [
    "Closed", "6:00 AM", "7:00 AM", "8:00 AM", "9:00 AM", "10:00 AM",
    "11:00 AM", "12:00 PM", "1:00 PM", "2:00 PM", "3:00 PM", "4:00 PM",
    "5:00 PM", "6:00 PM", "7:00 PM", "8:00 PM", "9:00 PM"
  ];

  // Synchronize operatingHours with formData.hours if formData.hours updates
  useEffect(() => {
    if (formData.hours) {
      setOperatingHours(formData.hours);
    }
  }, [formData.hours]);

  const handleToggleOpen = (day) => {
    const updatedHours = {
      ...operatingHours,
      [day]: {
        ...operatingHours[day],
        open: !operatingHours[day].open,
        start: !operatingHours[day].open ? "9:00 AM" : "Closed",
        end: !operatingHours[day].open ? "5:00 PM" : "Closed",
      },
    };
    setOperatingHours(updatedHours);
    setFormData((prevData) => ({ ...prevData, hours: updatedHours }));
  };

  const handleTimeChange = (day, type, value) => {
    const updatedHours = {
      ...operatingHours,
      [day]: {
        ...operatingHours[day],
        [type]: value,
      },
    };
    setOperatingHours(updatedHours);
    setFormData((prevData) => ({ ...prevData, hours: updatedHours }));
  };

  return (
    <div className="space-y-4">
      <label className="block text-sm font-medium text-gray-700 mb-2">Operating Hours</label>
      {Object.keys(operatingHours).map((day) => (
        <div key={day} className="flex items-center gap-x-4 gap-y-2 flex-wrap">
          <span className="w-24 text-gray-700">{day}</span>
          <input
            type="checkbox"
            checked={operatingHours[day].open}
            onChange={() => handleToggleOpen(day)}
            className="h-4 w-4"
          />
          <span className="text-gray-600">{operatingHours[day].open ? "Open" : "Closed"}</span>
          {operatingHours[day].open && (
            <>
              <select
                value={operatingHours[day].start}
                onChange={(e) => handleTimeChange(day, "start", e.target.value)}
                className="border rounded-md p-1"
              >
                {timeSlots.map((time) => (
                  <option key={time} value={time}>{time}</option>
                ))}
              </select>
              <span className="mx-1">to</span>
              <select
                value={operatingHours[day].end}
                onChange={(e) => handleTimeChange(day, "end", e.target.value)}
                className="border rounded-md p-1"
              >
                {timeSlots.map((time) => (
                  <option key={time} value={time}>{time}</option>
                ))}
              </select>
            </>
          )}
        </div>
      ))}
    </div>
  );
};

export default OperatingHoursInput;
